import type { StanFilterValue } from '@/components/core-components/StanFilters/types';
import { toSqlOperator } from '@/components/core-components/StanFilters/utils/filterMapping';

/**
 * Transform filter values to backend API format
 * Converts StanFilterValue array to JSON string for API consumption
 */
export const transformFiltersToApiFormat = (filterValues: StanFilterValue[]): string | undefined => {
    if (filterValues.length === 0) {
        return undefined;
    }

    const filterArray = filterValues.map(filter => ({
        fieldName: filter.id,
        operator: toSqlOperator(filter.operator),
        value: filter.value,
        type: filter.type,
        urlCode: filter.operator,
        ...(filter.secondValue && { secondValue: filter.secondValue }),
    }));

    return JSON.stringify(filterArray);
};
